export class PriceListModel {
    constructor(
      id,
      PartitionKey = PriceListModelDefaultPartitionKey,
      Type,
      Name,
      Active = true,
      CreatedAt = (new Date()).toISOString()
    ) {
      this.id = id;
      this.PartitionKey = PartitionKey;
      this.Type = Type
      this.Name = Name;
      this.Active = Active
      this.CreatedAt = CreatedAt
    }
  }

  export var PriceListModelDefaultPartitionKey = "Default";
  